import { D as DictionarySorter } from './dictionarySorter-1f1c5424.js';
import { D as DictionaryTranslator } from './dictionaryTranslator-6f7eced2.js';
import { D as DictionarySerializer } from './dictionarySerializer-969da3d0.js';
import { D as DictionaryFilter } from './dictionaryFilter-769f7408.js';

class DictionaryUtils {
}
DictionaryUtils.sorter = DictionarySorter;
DictionaryUtils.translator = DictionaryTranslator;
DictionaryUtils.serialization = DictionarySerializer;
DictionaryUtils.filtration = DictionaryFilter;

export { DictionaryUtils as D };
//# sourceMappingURL=dictionaryUtils-5efc68f5.js.map
